import { getFileExtension } from './analytics';

export function getFirstCitationPage(value: string | number | null | undefined): number | undefined {
  const match = String(value ?? '').match(/-?\d+/);
  if (!match) return undefined;

  const pageNumber = Number(match[0]);
  return Number.isSafeInteger(pageNumber) && pageNumber > 0 ? pageNumber : undefined;
}

export function appendPdfPageFragment(url: string, pageNumber: number): string {
  return `${url.split('#')[0]}#page=${pageNumber}`;
}

export function isPdfFilename(filename?: string | null): boolean {
  return getFileExtension(filename) === 'pdf';
}

export function openPdfPreviewAtPage(
  resolvePreviewUrl: () => Promise<string | null | undefined>,
  pageNumber: number,
  options: {
    onBlocked?: () => void | Promise<void>;
    onError?: (error: unknown) => void | Promise<void>;
  } = {},
): Promise<void> {
  const previewWindow = window.open('about:blank', '_blank');
  if (!previewWindow) {
    return Promise.resolve(options.onBlocked?.());
  }

  previewWindow.opener = null;

  return resolvePreviewUrl()
    .then((url) => {
      if (!url) {
        throw new Error('The PDF preview URL was empty');
      }

      const destination = appendPdfPageFragment(url, pageNumber);
      // eslint-disable-next-line no-restricted-syntax -- Navigates a separately opened popup, never the embed or host window.
      previewWindow.location.replace(destination);
    })
    .catch(async (error: unknown) => {
      previewWindow.close();
      await options.onError?.(error);
    });
}
